export default function groupBy<T>(inputArray: T[], predicate: ((T) => string) | string): any {
  const ret = {};
  const cb = typeof predicate === 'function' ? predicate : (element) => element[predicate];
  inputArray.forEach(e => {
    if (!ret[cb(e)]) {
      ret[cb(e)] = [];
    }
    ret[cb(e)].push(e);
  });
  return ret;
}
